import { useMutation, useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';

import { MERCHANDISING_COLLECTION_QUERY_KEY } from './useGetMerchandisingCollection';

import MerchandisingCollectionsService, {
  MerchandisingCollection,
} from '@/services/MerchandisingCollectionsService';

export function useGenerateMerchandisingCollectionPublicLink(
  collectionId: number,
) {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: () =>
      MerchandisingCollectionsService.generatePublicLink(collectionId),
    onSuccess: (data) => {
      const COLLECTION_QUERY_KEY = [
        ...MERCHANDISING_COLLECTION_QUERY_KEY,
        collectionId,
      ];

      if (data.opaqueId) {
        queryClient.setQueryData<MerchandisingCollection>(
          COLLECTION_QUERY_KEY,
          produce((draft) => {
            if (draft) {
              draft.opaqueId = data.opaqueId;
            }
          }),
        );
      }
    },
  });

  return {
    generatePublicLink: mutateAsync,
    isLoading: isPending,
  };
}
